export const AMTRAK_STATIONS = [
  { code: 'PHL', name: 'Philadelphia 30th Street' },
  { code: 'NYP', name: 'New York Penn Station' },
  { code: 'NHV', name: 'New Haven Union Station' },
  { code: 'BOS', name: 'Boston South Station' },
  { code: 'BAL', name: 'Baltimore Penn Station' },
  { code: 'WAS', name: 'Washington Union Station' },
  { code: 'RVR', name: 'Richmond' },
  { code: 'RGH', name: 'Raleigh' },
  { code: 'KBL', name: 'Kannapolis' },
  { code: 'CRO', name: 'Charlotte' },
  { code: 'GSO', name: 'Greensboro' },
  { code: 'SAV', name: 'Savannah' },
  { code: 'JAX', name: 'Jacksonville' },
  { code: 'ORL', name: 'Orlando' },
  { code: 'TPA', name: 'Tampa' },
  { code: 'MIA', name: 'Miami' },
  { code: 'CHI', name: 'Chicago Union Station' },
  { code: 'MIL', name: 'Milwaukee' },
  { code: 'MSN', name: 'Madison' },
  { code: 'STL', name: 'St. Louis' },
  { code: 'STU', name: 'St. Louis Union Station' },
  { code: 'KCY', name: 'Kansas City' },
  { code: 'DEN', name: 'Denver' },
  { code: 'SLC', name: 'Salt Lake City' },
  { code: 'SAC', name: 'Sacramento' },
  { code: 'EMR', name: 'Emeryville' },
  { code: 'OAK', name: 'Oakland Jack London Square' },
  { code: 'SFO', name: 'San Francisco Transbay' },
  { code: 'SJC', name: 'San Jose Diridon' },
  { code: 'LAX', name: 'Los Angeles Union Station' },
  { code: 'SDB', name: 'San Diego Santa Fe Depot' },
  { code: 'PHX', name: 'Phoenix' },
  { code: 'TUS', name: 'Tucson' },
  { code: 'ABQ', name: 'Albuquerque' },
  { code: 'DAL', name: 'Dallas' },
  { code: 'HOU', name: 'Houston' },
  { code: 'NOL', name: 'New Orleans Union Passenger Terminal' },
  { code: 'MCI', name: 'Kansas City Union Station' },
  { code: 'OMA', name: 'Omaha' },
  { code: 'MSP', name: 'Minneapolis St. Paul' },
  { code: 'SEA', name: 'Seattle King Street Station' },
  { code: 'PDX', name: 'Portland Union Station' },
];